class FulfilmentService {
    constructor($rootScope, restangular, bootstrap, analytics, addressService, settings) {
        this.$rootScope = $rootScope;
        this.bootstrap = bootstrap;
        this.api = restangular.one('Fulfilment');
        this.storeCodeApi = restangular.one('Storecode');
        this.analytics = analytics;
        this.addressService = addressService;
        this.bootstrap = bootstrap;
        this.settings = settings;

        this.fulfilmentOptions = {
            pickup: {
                name: settings.fulfilmentMethod.pickupOptionName,
                text: settings.fulfilmentMethod.pickupOptionMessage,
                value: settings.fulfilmentMethod.pickupOptionMessage,
                subheading: settings.fulfilmentMethod.pickupOptionSubheading,
                isVariableSubheading: false,
                icon: 'iconww-Cart',
                addressText: 'select supermarket',
                type: 'pickup',
            },
            delivery: {
                name: settings.fulfilmentMethod.deliveryOptionName,
                text: settings.fulfilmentMethod.deliveryOptionMessage,
                value: settings.fulfilmentMethod.deliveryOptionMessage,
                subheading: settings.fulfilmentMethod.deliveryOptionSubheading,
                isVariableSubheading: true,
                icon: 'iconww-Cart',
                addressText: 'select address',
                type: 'delivery',
            },
            none: {
                name: settings.fulfilmentMethod.noneOptionName,
                text: settings.fulfilmentMethod.noneOptionMessage,
                value: settings.fulfilmentMethod.noneOptionMessage,
                subheading: settings.fulfilmentMethod.noneOptionSubheading,
                isVariableSubheading: false,
                selected: true,
                icon: 'iconww-Cart',
                type: 'none',
            },
        };

        this.fulfilmentSteps = {
            fulfilmentMethod: 'FULFILMENT_METHOD',
            address: 'ADDRESS',
            timeslot: 'TIMESLOT',
            billing: 'BILLING',
        };

        this.checkoutFulfilmentOptions = {
            pickup: this.fulfilmentOptions.pickup,
            delivery: this.fulfilmentOptions.delivery,
        };

        this.selectedFulfilmentMethod = this.fulfilmentOptions.none;

        this.setFulfilmentFromBootstrap();
    }

    setFulfilmentFromBootstrap() {
        this.setDeliveryInfo(this.bootstrap.getBootstrappedDataIfPresent(this.bootstrap.bootstrapped.DeliveryInfo));

        // Update the fulfilment subheading - if it's express delivery
        if (this.selectedFulfilmentMethod === this.fulfilmentOptions.delivery && this.isExpress) {
            this.fulfilmentOptions.delivery.subheading = this.settings.fulfilmentMethod.expressDeliveryOptionSubheading;
        }
    }

    setDeliveryInfo(deliveryInfo) {
        if (deliveryInfo == null) return;

        this.selectedFulfilmentMethod = deliveryInfo.DeliveryMethod === 'Courier' ? this.fulfilmentOptions.delivery : this.fulfilmentOptions.pickup;
        this.reservedDate = deliveryInfo.ReservedDate && deliveryInfo.ReservedDate.AbsoluteDateText ? deliveryInfo.ReservedDate : null;
        this.reservedTime = deliveryInfo.ReservedTime && deliveryInfo.ReservedTime.Id > 0 ? deliveryInfo.ReservedTime : null;
        this.isExpress = deliveryInfo.IsExpress;
        this.savedAddress = deliveryInfo.Address && deliveryInfo.Address.AddressId > 0 ? deliveryInfo.Address : null;
    }

    changeFulfilmentTimeslot() {
        if (!this.savedAddress || this.isNotSet()) {
            this.setFulfilmentFromBootstrap();
        }

        this.$rootScope.$broadcast('fulfilment:changeTimeslot');
    }

    changeFulfilmentMethod() {
        this.selectedFulfilmentMethod = this.fulfilmentOptions.none;
        this.$rootScope.$broadcast('fulfilment:changeMethod');
    }

    clearFulfilmentInfo() {
        this.selectedFulfilmentMethod = this.fulfilmentOptions.none;
        this.clearAddressAndTime();
    }

    clearAddressAndTime() {
        this.savedAddress = null;
        this.clearTime();
    }

    clearTime() {
        this.reservedDate = null;
        this.reservedTime = null;
    }

    canOrderBeFulfilled() {
        return this.selectedFulfilmentMethod !== this.fulfilmentOptions.none
            && !!this.savedAddress
            && !!this.reservedDate
            && !!this.reservedTime
            && !!this.addressService.getPrimaryAddress();
    }

    isDelivery() {
        return this.selectedFulfilmentMethod.name === this.fulfilmentOptions.delivery.name;
    }

    isPickup() {
        return this.selectedFulfilmentMethod.name === this.fulfilmentOptions.pickup.name;
    }

    isNotSet() {
        return this.selectedFulfilmentMethod.name === this.fulfilmentOptions.none.name;
    }

    setStore(storeCode) {
        return this.storeCodeApi.doPOST({ storeCode });
    }

    saveFulfilment(fulfilmentInfo) {
        return this.api.doPOST({
            fulfilmentMethod: fulfilmentInfo.fulfilmentMethod,
            addressId: fulfilmentInfo.address.AddressId,
            timeslotId: fulfilmentInfo.fulfilmentWindow.time ? fulfilmentInfo.fulfilmentWindow.time.Id : undefined,
            windowDate: fulfilmentInfo.fulfilmentWindow.date ? fulfilmentInfo.fulfilmentWindow.date.Date : undefined,
            billingAddressId: fulfilmentInfo.billingAddressId,
        }).then((response) => {
            if (fulfilmentInfo.fulfilmentMethod
                && fulfilmentInfo.address
                && fulfilmentInfo.fulfilmentWindow.date
                && fulfilmentInfo.fulfilmentWindow.time) {
                this.analytics.push({
                    data: fulfilmentInfo,
                    type: this.analytics.mapperTypes.shop.fulfilment,
                });
            }
            return response;
        });
    }
}

FulfilmentService.$inject = ['$rootScope', 'Restangular', 'BootstrapService', 'AnalyticsService', 'AddressService', 'Settings'];

module.exports = FulfilmentService;



// WEBPACK FOOTER //
// ./src/fulfilment/fulfilment.service.js